export enum AgentApplicationStatus {
  AwaitApplicationReview = 1,
  AwaitExamCompletion,
  AwaitApprovalForPayment,
  AwaitPayment,
  AwaitAccreditationApproval,
  Accredited,
  Rejected,
}